"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimecardStatus = exports.DisputeStatus = exports.FundingSourceStatus = exports.AgencyPayoutStatusEnum = exports.PayoutStatusEnum = exports.JobBillingCategory = void 0;
var JobBillingCategory;
(function (JobBillingCategory) {
    JobBillingCategory["Standard"] = "standard";
    JobBillingCategory["Disputable"] = "disputable";
})(JobBillingCategory = exports.JobBillingCategory || (exports.JobBillingCategory = {}));
var PayoutStatusEnum;
(function (PayoutStatusEnum) {
    PayoutStatusEnum["Canceled"] = "canceled";
    PayoutStatusEnum["Paid"] = "paid";
    PayoutStatusEnum["Hold"] = "hold";
    PayoutStatusEnum["Failed"] = "failed";
    PayoutStatusEnum["InTransit"] = "in_transit";
    PayoutStatusEnum["Approved"] = "approved";
    PayoutStatusEnum["Open"] = "open";
    PayoutStatusEnum["Pending"] = "pending";
    PayoutStatusEnum["Submitted"] = "submitted";
})(PayoutStatusEnum = exports.PayoutStatusEnum || (exports.PayoutStatusEnum = {}));
var AgencyPayoutStatusEnum;
(function (AgencyPayoutStatusEnum) {
    AgencyPayoutStatusEnum["Canceled"] = "canceled";
    AgencyPayoutStatusEnum["Paid"] = "paid";
    AgencyPayoutStatusEnum["Failed"] = "failed";
    AgencyPayoutStatusEnum["Pending"] = "pending";
    AgencyPayoutStatusEnum["Processing"] = "processing";
})(AgencyPayoutStatusEnum = exports.AgencyPayoutStatusEnum || (exports.AgencyPayoutStatusEnum = {}));
var FundingSourceStatus;
(function (FundingSourceStatus) {
    FundingSourceStatus["Active"] = "active";
    FundingSourceStatus["FailedSetup"] = "failed_setup";
    FundingSourceStatus["Inactive"] = "inactive";
    FundingSourceStatus["Processing"] = "processing";
})(FundingSourceStatus = exports.FundingSourceStatus || (exports.FundingSourceStatus = {}));
var DisputeStatus;
(function (DisputeStatus) {
    DisputeStatus["New"] = "new";
    DisputeStatus["InProgress"] = "in_progress";
    DisputeStatus["OnHold"] = "on_hold";
    DisputeStatus["Resolved"] = "resolved";
    DisputeStatus["RequireFacilityEmail"] = "require_facility_email";
    DisputeStatus["WaitingForProToRespond"] = "waiting_for_pro_to_respond";
    DisputeStatus["NeedsAdditionalReview"] = "needs_additional_review";
    DisputeStatus["Form530UploadedAndNeedsReview"] = "530_uploaded_and_needs_review";
})(DisputeStatus = exports.DisputeStatus || (exports.DisputeStatus = {}));
var TimecardStatus;
(function (TimecardStatus) {
    TimecardStatus["Open"] = "open";
    TimecardStatus["Submitted"] = "submitted";
    TimecardStatus["Approved"] = "approved";
})(TimecardStatus = exports.TimecardStatus || (exports.TimecardStatus = {}));
